/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = { showDetails: 'showDetails', nights: 'nights', days: 'days' }; export default Keys;